import { Engine, Actor, Color, Vector, vec, CollisionType, CollisionGroup } from 'excalibur';
import { collision_groups } from '../scenes/level-one/collision_groups';
import { Enemy } from './enemies/enemy';
import { Turn } from './turn';

class Path extends Actor {
    constructor(x : number, y : number, height : number, width : number, anchorX, anchorY, rotation) {
        super({
            x: x,
            y: y,
            rotation : rotation,

            anchor : vec(anchorX, anchorY),

            height: height,
            width: width,
            
            color: Color.fromRGB(0, 0, 0, 0),
            collisionGroup: CollisionGroup.collidesWith([])
        });
    }
}

export { Path }
